import { createTheme } from "@mui/material/styles";

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: "#dc582a",
    },
    secondary: {
      main: "#472b74",
    },
    background: {
      default: "#FFFAFA",
    },
  },
  typography: {
    fontFamily: "Montserrat, sans-serif",
  },
});

export default theme;
